import type { DeviceCategory } from "../deviceCategories";

/** How many devices an automatic split puts on one circuit, until he picks another number. */
export const DEFAULT_SPLIT_SIZE: Record<DeviceCategory, number> = {
  lighting: 12,
  emergencyLighting: 20,
  sockets: 8,
  buildingServices: 6,
  fireAlarm: 32,
  intruderAlarm: 16,
  data: 12,
  earthing: 12,
};

export const FALLBACK_SPLIT_SIZE = 10;
